import { render, staticRenderFns } from "./tagManager.vue?vue&type=template&id=788d5cec&scoped=true&"
import script from "./tagManager.vue?vue&type=script&lang=js&"
export * from "./tagManager.vue?vue&type=script&lang=js&"
import style0 from "./tagManager.vue?vue&type=style&index=0&id=788d5cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788d5cec",
  null
  
)

export default component.exports